import styled from '@emotion/styled';
import { Card as MuiCard } from '@mui/material';

export const TableCard = styled(MuiCard)(({ theme }) => ({
    borderRadius: '8px',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.4)',
    border: '1px solid #EAECF0'
}));
